module.exports = __webpack_public_path__ + "static/media/mews_logotype.f1b2c6c1.png";